module.exports = __webpack_public_path__ + "static/img/error_no_data.ca2e73cd.png";